<template>
  <CustomModal
    :show="show"
    :title="title"
    :icon="icon"
    :iconColor="iconColor"
    :width="width"
    :loading="loading"
    @close="$emit('close')"
  >
    <div class="text-body-1" style="color: #334155">
      <slot>{{ message }}</slot>
    </div>

    <template #actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" text color="textPrimary" @click="$emit('close')" class="font-weight-medium">
        {{ cancelText }}
      </v-btn>
      <v-btn
        :loading="loading"
        :disabled="confirmDisabled || loading"
        :color="confirmColor"
        :dark="!loading && !confirmDisabled"
        @click="$emit('confirm')"
        class="font-weight-medium"
      >
        <v-icon v-if="confirmIcon" left>{{ confirmIcon }}</v-icon>
        {{ confirmText }}
      </v-btn>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/CustomModal.vue";

export default {
  name: "ConfirmDialog",
  components: { CustomModal },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-alert-circle-outline",
    },
    iconColor: {
      type: String,
      default: "#334155",
    },
    width: {
      type: [String, Number],
      default: "500",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmDisabled: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: "Confirmar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
    confirmColor: {
      type: String,
      default: "error",
    },
    confirmIcon: {
      type: String,
      default: null,
    },
  },
};
</script>
